import { render, staticRenderFns } from "./NonIncome.vue?vue&type=template&id=47e30962"
import script from "./NonIncome.vue?vue&type=script&lang=js"
export * from "./NonIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports